import React, { Component } from 'react';
import styled from 'styled-components';
import api from 'api';
import moment from 'moment';

import { capitalize, scrollWindowTo } from 'helpers';
import WP from 'WP';

import ConferenceOrderInput from './ConferenceOrderInput';
import SuccessForm from './SuccessForm';
import ContactForm from '../Rental/Forms/ContactForm';
import GridElement from 'partials/GridElement';
import Html from 'partials/Html'; 
import LoadingButton from 'partials/LoadingButton';
import Button from 'partials/Button';

import Media from 'css/Media';

class ConferenceRequestForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            personalia: {
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                adress: '',
                postalCode: '',
                city: '',
            },
            defaultValue: null,
            numPersons: '',
            duration: '',
            drinksAndSnacks: false,
            lunch: false,
            dinner: false,
            disabled: false,
            date: null,
            dateValid: true,
            message: '',
        }
    }

    componentDidMount() {
        api.conferenceVenuesFetcher.getAll().then(r => this.makeDropDownOptions(r))
        this.setState({defaultValue: this.props.defaultValue})
    }

    componentDidUpdate(prevProps) {
        if(prevProps.defaultValue !== this.props.defaultValue) {
            let products = this.state.products;
            products.push(this.props.defaultValue.value)
            this.setState({products: products})
        }
    }

    makeDropDownOptions = r => {
        let options = [];

        r.data.map(venue => {
            options.push({label: venue.acf.title, value: venue.id});
            return null;
        })

        this.setState({venueOptions: options})
    }


    handleOnChange = e => {
        let name = e.target.name;
        let value = e.target.value;

        this.setState({personalia: {...this.state.personalia, [name]: value}});
    }

    handleInputChange = e => {
        let name = e.target.name;
        let value = e.target.value;

        this.setState({ [name]: value });
    }

    setDropdownValue = e => {
        console.log('running', e)
        this.setState({ venueName: e });
    }

    handleCheck = e => {
        let target = e.target;
        this.setState({[target.name]: !this.state[e.target.name]})
    }

    setDate = dateObj => {
        let string = capitalize(moment(new Date(dateObj)).format('dddd D. MMM. YYYY,'));
        this.setState({date: dateObj, dateStr: string, dateValid: true})
    }

    getBookedVenue() {
        let venueId;
        if(this.state.venueName) {
            if(this.state.venueName === this.state.defaultValue.value) {
                venueId = this.state.defaultValue.value;
            } else venueId = this.state.venueName;
        } else venueId = this.state.defaultValue.value;
        api.conferenceVenuesFetcher.getByIds({ids: [venueId]}).then(r => this.validateFields(r.data[0]));

        this.setState({submitting: true})
    }

    validateFields = venue => {
        const { personalia, defaultValue, numPersons, date, duration } = this.state;
        let contact = document.getElementById('contact_form');
        let conference_form = document.getElementById('conference_request_form');
        console.log('venue',venue)

        if( defaultValue && numPersons.length > 0 && duration.length > 0) {
            if(date) {
                if(
                    personalia.firstName.length > 0 && 
                    personalia.lastName.length > 0 && 
                    personalia.email.length > 0 && 
                    personalia.phone.length > 0 && 
                    personalia.adress.length > 0 && 
                    personalia.postalCode.length > 0 && 
                    personalia.city.length > 0
                ){
                    this.handleSubmit(venue);
                } else {
                    this.setState({submitting: false})
                    scrollWindowTo(contact, 500, 'easeInOutCubic');
                }
            } else {
                this.setState({
                    dateValid: false,
                    submitting: false
                })
                scrollWindowTo(conference_form, 500, 'easeInOutCubic');
            }
        } else {
            this.setState({submitting: false})
            scrollWindowTo(conference_form, 500, 'easeInOutCubic');
        }
    }

    handleSubmit = venue => {
        api.sendConferenceEnquiry({
            bookingEmail: venue.acf.booking_email_adress,
            venueName: venue.acf.title,
            numPersons: this.state.numPersons,
            date: this.state.dateStr,
            duration: this.state.duration,
            drinksAndSnacks: this.state.drinksAndSnacks ? 'yes' : 'no',
            lunch: this.state.lunch ? 'yes' : 'no',
            dinner: this.state.dinner ? 'yes' : 'no',
            message: this.state.message,
            name: this.state.personalia.firstName + ' ' + this.state.personalia.lastName,
            phone: this.state.personalia.phone,
            email: this.state.personalia.email,
            adress: this.state.personalia.adress,
            postalCode: this.state.personalia.postalCode,
            city: this.state.personalia.city,
        }).then(resp => {
            if(resp.data) {
                this.displaySuccess();
            } else console.log('Something went wrong: ', resp)
            this.setState({submitting: false})
        })
    }

    displaySuccess = () => {
        let form = document.getElementById('form');

        this.setState({submitted: true})
        scrollWindowTo(form, 500, 'easeInOutCubic');
    }

    render() {
        const { venue, showConferenceForm } = this.props;
        const {
            personalia,
            defaultValue,
            numPersons,
            date,
            duration,
            venueOptions,
            validEmailFormat,
            disabled,
            dateValid,
            submitting,
            submitted,
        } = this.state;

        return (
            <React.Fragment>
                { !submitted && showConferenceForm ?
                    <FormGrid id="form">
                    <TitleGridElement
                        id="conference_request_form"
                        colStart={{default: 1, s: 3, m: 3}}
                        colEnd={{default: 8, s: 14, m: 14}}
                        rowStart={1}
                    >
                        <h4>{venue.form_title}</h4>
                    </TitleGridElement>
                    { venueOptions ? 
                        <GridElement
                            colStart={{default: 1, s: 3, m: 3}}
                            colEnd={{default: 8, s: 14, m: 14}}
                            rowStart={2}
                        >
                            <ConferenceOrderInput 
                                defaultValue={defaultValue}
                                venueOptions={venueOptions} 
                                text={venue.acf.checkbox_options_text_description}
                                handleCheck={this.handleCheck}
                                handleInputChange={this.handleInputChange}
                                handleDropdownChange={this.setDropdownValue}
                                numPersons={numPersons}
                                date={date}
                                duration={duration}
                                dateValid={dateValid}
                                setDate={this.setDate}
                            />
                        </GridElement>
                    : null}
                    <DividerGridElement
                        colStart={{default: 1, s: 1, m: 1}}
                        colEnd={{default: 8, s: 16, m: 16}}
                        rowStart={3}
                    />
                    <GridElement
                        id="contact_form"
                        colStart={{default: 1, s: 1}}
                        colEnd={{default: 8, s: 16}}
                        rowStart={4}
                    >
                        <ContactForm
                            personalia={personalia}
                            handleOnChange={this.handleOnChange}
                            validateEmailFormat={this.validateEmailFormat}
                            validEmailFormat={validEmailFormat}
                        />
                    </GridElement>
                    { venue.form_text_content &&
                        <HtmlGridElement
                            colStart={{default: 1, s: 3}}
                            colEnd={{default: 8, s: 14}}
                            rowStart={5}
                        >
                        <Html content>{venue.form_text_content}</Html>
                    </HtmlGridElement>}
                    <InputGridElement
                        colStart={{default: 1, s: 5, m: 11}}
                        colEnd={{default: 4, s: 12, m: 14}}
                        colSpan
                        rowStart={6}
                        align="center"
                    >
                        { submitting ?
                            <LoadingButton placeholder={WP.trans.sendReservation} />
                            :
                            <Button 
                                onClick={disabled ? null : () => this.getBookedVenue()} 
                                tabIndex={1}
                            >
                                { submitted ? 
                                    WP.trans.thanks : 
                                    WP.trans.sendReservation
                                }
                            </Button>
                        }
                    </InputGridElement>
                </FormGrid>
                : showConferenceForm && <SuccessForm />}
        </React.Fragment>
        )
    }
}


export default ConferenceRequestForm;

const FormGrid = styled.div`
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: (1fr .359fr)[3] 1fr;
    grid-template-columns: repeat(3, 1fr .359fr) 1fr;
    -ms-grid-rows: ${props => props.rows || 'auto'};
    grid-template-rows: ${props => props.rows || 'auto'};
    margin-bottom: ${props => props.theme.spacing.elementM};

    ${Media.greaterThan('s')`
        -ms-grid-columns: (1fr .67fr)[7] 1fr;
        grid-template-columns: repeat(7, 1fr .67fr) 1fr;
        padding: ${props => props.theme.spacing.elementL} 0 ${props => props.theme.spacing.blockM};
        margin-bottom: ${props => props.theme.spacing.blockL};
        border: 1px solid ${props => props.theme.colors.text};
    `}

    ${Media.greaterThan('m')`
        -ms-grid-columns: (1fr .435fr)[7] 1fr;
        grid-template-columns: repeat(7, 1fr .435fr) 1fr;
    `}
`

const TitleGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentXL};

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.elementM};
    `}
`

const HtmlGridElement = styled(GridElement)`

    padding-bottom: ${props => props.theme.spacing.contentXL};

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.blockXS};
    `}
`

const DividerGridElement = styled(GridElement)`
    width: 100%;
    padding-top: ${props => props.theme.spacing.elementL};
    margin-bottom: 0;

    ${Media.greaterThan('s')`
        border-bottom: 1px solid ${props => props.theme.colors.lines};
        padding-top: ${props => props.theme.spacing.blockS};
        margin-bottom: ${props => props.theme.spacing.blockS};
    `}
`

const InputGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentXL};
    
    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.elementXS};

        &:last-of-type {
            padding-bottom: ${props => props.theme.spacing.elementM};
        }
    `}
`